import { displayName } from "react-quill";

export const styleSheet = (theme) => ({
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#E5E5E5",
    color: "white",
    fontWeight: "500",
    padding: "10px 20px !important",
  },
  modalTitle: {
    fontSize: "14px !important",
    fontWeight: "500 !important",
    textTransform: "capitalize !important",
    color: "black !important",
  },
  modalContent: {
    padding: "30px 20px !important",
  },
  inputLabel: {
    fontSize: "14px !important",
    fontWeight: "400 !important",
    textTransform: "capitalize !important",
    color: "#565656 !important",
    marginBottom: "16px",
  },
  cancelButton: {
    minWidth: "80px !important",
    height: "30px !important",
    fontSize: "13px !important",
    fontWeight: "500 !important",
    textTransform: "capitalize !important",
    backgroundColor: "#EBEBEB !important",
    color: "black !important",
    borderRadius: "4px !important",
  },
  doneButton: {
    minWidth: "80px !important",
    height: "30px !important",
    fontSize: "13px !important",
    fontWeight: "500 !important",
    textTransform: "capitalize !important",
    backgroundColor: "black !important",
    color: "white !important",
    borderRadius: "4px !important",
    "&.Mui-disabled": {
      backgroundColor: "rgba(217, 217, 217, 0.15) !important", // Custom disabled background color
      color: "rgba(0, 0, 0, 0.15) !important", // Custom disabled text color
    },
  },
  EditMlsField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#F6F6F6", // your background color
      borderRadius: "4px", // optional
      "& fieldset": {
        borderColor: "#D0D0D0", // normal border color
      },
      "&:hover fieldset": {
        borderColor: "#1565c0", // hover border color
      },
      "&.Mui-focused fieldset": {
        borderColor: "#0d47a1", // focus border color
      },
    },
  },
  NoteSection: {
    display: "flex !important",
    justifyContent: "flex-start !important",
    alignItems: "flex-start  !important",
    gap: "10px",
    color: "#565656 !important",
    marginTop: "10px",
  },
  NoteSectionContent: {
    fontSize: "12px !important",
    fontWeight: "400 !important",
    textTransform: "capitalize !important",
    color: "#565656 !important",
  },
  newFolderButton: {
    fontSize: "13px !important",
    fontWeight: "500 !important",
    textTransform: "capitalize !important",
    textDecoration: "underline !important",
  },
  detailHeading: {
    fontSize: "15px !important",
    fontFamily: "AvenirNext !important",
    color: "#252b33 !important",
    fontWeight: "600 !important",
  },
  detailCaption: {
    fontSize: "14px !important",
    fontFamily: "AvenirNext !important",
    color: "#767486 !important",
  },
  tabsContainer: {
    "& .MuiButtonBase-root": {
      padding: "6px 55px !important",
      Height: "30px !important",
      textTransform: "capitalize !important",
    },
    "& .Mui-selected": {
      color: "#252b33 !important",
      fontWeight: "500 !important",
    },
    "& .MuiTab-root": {
      fontWeight: "500 !important",
    },
    "& .MuiTabs-indicator": {
      height: "4px !important",
      backgroundColor: "#2868D7 !important",
    },
  },
  tabDetail: {
    display: "flex !important",
    flexDirection: "column !important",
    gap: "6px !important",
    paddingBottom: "16px",
  },
  tabDetailItem: {
    display: "flex !important",
    justifyContent: "space-between !important",
    alignItems: "center !important",
  },
  tabDetailItemLabel: {
    width: "100px",
    fontSize: "12px !important",
    color: "#252b33 !important",
    fontWeight: "400 !important",
  },
  tabDetailItemValue: {
    flex: 1,
    fontSize: "12px !important",
    color: "#767486 !important",
    fontWeight: "400 !important",
    whiteSpace: "nowrap !important",
    textOverflow: "ellipsis !important",
    overflow: "hidden !important",
  },
  subHeading: {
    fontSize: "18px !important",
    marginTop: "16px !important",
  },
  contentContainer: {
    display: "flex !important",
    flexDirection: "column !important",
    gap: "8px !important",
    paddingBottom: "16px",
    marginTop: "10px",
  },
  contentItem: {
    display: "flex !important",
    justifyContent: "flex-start !important",
    alignItems: "center !important",
    gap: "12px !important",
  },
  activityContainer: {
    display: "flex !important",
    flexDirection: "column !important",
    gap: "6px !important",
    "& .MuiPaper-root": {
      boxShadow: "none !important",
    },
  },
  activityHeading: {
    fontSize: "14px !important",
    fontFamily: "AvenirNext !important",
    color: "#252b33 !important",
    fontWeight: "600 !important",
  },
  activityCard: {
    marginTop: "5px !important",
    backgroundColor: "white !important",
    padding: "6px 10px !important",
    borderLeft: "4px solid #58dbac !important",
    display: "flex !important",
    flexDirection: "column !important",
    gap: "12px !important",
  },
  activityItemBadge: {
    backgroundColor: "#58dbac !important",
    color: "white !important",
    fontSize: "9px !important",
    padding: "0px 5px !important",
  },
  activityItem: {
    display: "flex !important",
    justifyContent: "space-between !important",
    alignItems: "center !important",
  },
  activityItemDate: {
    fontSize: "9px !important",
    fontFamily: "AvenirNext !important",
    color: "#767486 !important",
  },
  activityAvatarDecContainer: {
    display: "flex !important",
    flexDirection: "column !important",
    gap: "0px !important",
  },
  activityAvatarContainer: {
    display: "flex !important",
    justifyContent: "flex-start !important",
    alignItems: "center !important",
    gap: "8px !important",
  },
  peopleAvatarContainer: {
    display: "flex !important",
    justifyContent: "flex-start !important",
    alignItems: "center !important",
    gap: "15px !important",
  },
  activityAvatarDecContainerHeading: {
    fontSize: "9px !important",
    fontFamily: "AvenirNext !important",
    color: "#252b33 !important",
  },
  peopleAvatarDecContainerHeading: {
    fontSize: "px !important",
    fontFamily: "AvenirNext !important",
    color: "#252b33 !important",
  },
  activityAvatarDecContainerCaption: {
    fontSize: "9px !important",
    fontFamily: "AvenirNext !important",
    color: "#767486 !important",
  },
  peopleAvatarDecContainerCaption: {
    fontSize: "11px !important",
    fontFamily: "AvenirNext !important",
    color: "#767486 !important",
  },
  activityCardRight: {
    display: "flex !important",
    flexDirection: "column !important",
    gap: "0px !important",
  },
  activityCardDetail: {
    fontSize: "10px !important",
    fontFamily: "AvenirNext !important",
    color: "#2868D7  !important",
    textDecoration: "underline !important",
    textTransform: "capitalize !important",
  },
});
